<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="bk_1" role="doc-chapter">
<figure class="figure">
<p class="figh"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><img alt="" height="401" src="images/chi-gunn-frontispiece.jpeg" width="600"/></p>
<p class="figh">President Trump prepares to welcome the Clemson Tigers to the White House on Monday, January 14, 2019. Official White House photo by Joyce N. Boghosian, courtesy of the White House.</p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gunn-0003.vue?51e57ef8